import { defineMessages } from "react-intl";

export default defineMessages({
  coverage: {
    id: "policycommon.component.umbrella-coverage.Coverage",
    defaultMessage: "Coverage",
  },
 
  limits: {
    id: "policycommon.component.umbrella-coverage.Limits",
    defaultMessage: "Limits",
  },
  deductible: {
    id: "policycommon.component.umbrella-coverage.Deductible",
    defaultMessage: "Deductible",
  },
  policyNumber: {
    id: "policycommon.component.umbrella-underlying-policy.PolicyNumber",
    defaultMessage: "Policy Number",
  },
  liabilityLimit: {
    id: "policycommon.component.umbrella-underlying-policy.LiabilityLimit",
    defaultMessage: "Liability Limit",
  },
  underlyingPolicyDetails: {
    id: "policycommon.component.umbrella-underlying-policy.UnderlyingPolicyDetails",
    defaultMessage: "Underlying Policy Details",
  },
});
